import i18n from '../i18n'

/**
 * The 75/55 score bands (docs/design-system.md, "بازهٔ امتیاز"), tightened
 * from 70/50 on 2026-09-07 per owner decision — mirrors `Scoring.bandOf` in
 * the Android app exactly (tooti-android/.../core/score/Scoring.kt),
 * edge-tested there at 54/55/74/75. Deliberately open bands to keep practice
 * encouraging; not a threshold this client should ever need to change on its
 * own — if the owner revises it, both clients move together.
 */

const t = (key, options) => i18n.t(key, { ns: 'review', ...options })

export const GOOD_FROM = 75
export const MID_FROM = 55

export function bandOf(score) {
  if (score >= GOOD_FROM) return 'good'
  if (score >= MID_FROM) return 'warn'
  return 'bad'
}

/**
 * A word's score as the server computed it (V1-b `score`, pulled toward the
 * weakest phoneme), or Azure's `accuracy` for a response that predates it.
 */
export function wordScore(word) {
  const score = Number(word?.score)
  if (Number.isFinite(score)) return score
  return Number(word?.accuracy ?? 0)
}

/**
 * The colour band of one word. The server owns the rule (V1-b: AppSetting
 * thresholds, weakest-phoneme weighting) and sends `band` as
 * good | mid | bad; this maps it onto the client's good | warn | bad tokens
 * and falls back to the local 75/55 band of the score for a cached or
 * older result that carries no `band`.
 */
export function wordBand(word) {
  const fromServer = { good: 'good', mid: 'warn', bad: 'bad' }[word?.band]
  return fromServer ?? bandOf(wordScore(word))
}

export function bandLabel(band) {
  const labels = { good: t('band.good'), warn: t('band.warn'), bad: t('band.bad') }
  return labels[band]
}
